import gql from 'graphql-tag';

import { VISIBLE_RESOURCES_STATUSES } from 'src/data/performance';
import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendIntegrationAsset, BackendQueryIntegrationAssetsArgs } from 'src/types/backend';

const QUERY = gql`
  query IntegrationPerformanceData(
    $customerId: ID!
    $accountId: ID
    $dataSource: PerformanceCenterDataSource
    $statuses: [IntegrationAssetStatus!]
  ) {
    integrationAssets(
      customerId: $customerId
      dataSource: $dataSource
      accountId: $accountId
      statuses: $statuses
    ) {
      id
      performanceData
    }
  }
`;

type Variables = Pick<BackendQueryIntegrationAssetsArgs, 'customerId' | 'dataSource' | 'accountId'>;
type Result = Pick<BackendIntegrationAsset, 'id' | 'performanceData'>[];

export const queryIntegrationPerformanceData = async (
  { customerId, dataSource, accountId }: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      dataSource,
      accountId,
      statuses: VISIBLE_RESOURCES_STATUSES,
    },
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  return getSingleProp<Result>(result.data);
};
